module.exports = "/next-static/_next/static/images/hero_image_large-8f76e397bd53eb83312e31073cce4db5.webp";